var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Color, Size, FontWeight } from '../const/index';
function Button(props) {
    return React.createElement(StyledButton, __assign({}, props));
}
Button.defaultProps = {
    type: 'button',
};
Button.displayName = 'Button';
var StyledButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: none;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: inline-block;\n  font-size: ", "px;\n  font-weight: ", ";\n  height: ", ";\n  min-width: ", ";\n  padding: 0 ", ";\n  white-space: nowrap;\n  ", " ", "\n\n  &:hover {\n    background: ", ";\n    cursor: pointer;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    background: ", ";\n  }\n"], ["\n  border: none;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: inline-block;\n  font-size: ", "px;\n  font-weight: ", ";\n  height: ", ";\n  min-width: ", ";\n  padding: 0 ", ";\n  white-space: nowrap;\n  ", " ",
    "\n\n  &:hover {\n    background: ",
    ";\n    cursor: pointer;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    background: ",
    ";\n  }\n"])), Size.FONT.BASE, function (props) { return (props.danger ? FontWeight.BOLD : FontWeight.NORMAL); }, function (_a) {
    var flat = _a.flat;
    return !flat && '40px';
}, function (_a) {
    var flat = _a.flat;
    return !flat && '70px';
}, function (_a) {
    var flat = _a.flat;
    return !flat && '16px';
}, function (props) { return colors(props); }, function (props) {
    return props.disabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      opacity: 0.3;\n      pointer-events: none;\n    "], ["\n      opacity: 0.3;\n      pointer-events: none;\n    "])));
}, function (props) {
    return !props.flat && props.primary ? Color.SOFT_BLUE : Color.WHITE;
}, function (props) {
    return !props.flat && props.primary
        ? Color.STRONG_BLUE_3
        : Color.VERY_LIGHT_GRAY_3;
});
var colors = function (props) {
    if (props.flat) {
        return "\n      background: none;\n      color: " + Color.BRAND_PRIMARY + ";\n      font-weight: " + (props.primary && FontWeight.BOLD) + ";\n    ";
    }
    else if (props.primary) {
        return "\n      background: " + Color.BRAND_PRIMARY + ";\n      box-shadow: inset 0 1px 0 0 " + Color.STRONG_BLUE + ",\n        inset -1px 0 0 0 " + Color.STRONG_BLUE + ",\n        inset 1px 0 0 0 " + Color.STRONG_BLUE + ",\n        inset 0 -2px 0 0 " + Color.STRONG_BLUE + ";\n      color: " + Color.WHITE + ";\n    ";
    }
    else if (props.danger) {
        return "\n      background: " + Color.BACKGROUND_COLOR_BODY_BASE + ";\n      box-shadow: inset 0 1px 0 0 " + Color.LIGHT_GRAY + ",\n        inset -1px 0 0 0 " + Color.LIGHT_GRAY + ",\n        inset 1px 0 0 0 " + Color.LIGHT_GRAY + ",\n        inset 0 -2px 0 0 " + Color.LIGHT_GRAY + ";\n      color: " + Color.SOFT_RED + ";\n    ";
    }
    else {
        return "\n      background: " + Color.BACKGROUND_COLOR_BODY_BASE + ";\n      box-shadow: inset 0 1px 0 0 " + Color.LIGHT_GRAY + ",\n        inset -1px 0 0 0 " + Color.LIGHT_GRAY + ",\n        inset 1px 0 0 0 " + Color.LIGHT_GRAY + ",\n        inset 0 -2px 0 0 " + Color.LIGHT_GRAY + ";\n      color: " + Color.DARK_GRAY + ";\n    ";
    }
};
export default Button;
var templateObject_1, templateObject_2;
//# sourceMappingURL=button.js.map